import React from "react";

const Services = () => {
  return <h1>LEARNING CENTER</h1>;
};

export default Services;